module.exports = __webpack_public_path__ + "img/s1-9.7241dcd4.jpeg";